export const routes = [
  {
    path: "/",
    exact: false,
    component: require('@/layouts/index.js').default || require('@/layouts/index.js'),
    routes: [
    {
      path: "/report/bhc",
      exact: true,
      component: require('@/pages/report/bhc/index.js').default || require('@/pages/report/bhc/index.js'),
    },
    {
      path: "/report/perform_sales",
      exact: true,
      component: require('@/pages/report/perform_sales/index.js').default || require('@/pages/report/perform_sales/index.js'),
    },
    {
      path: "/ec/dashboard",
      exact: true,
      component: require('@/pages/ec/dashbord/index.js').default || require('@/pages/ec/dashbord/index.js'),
    },
    {
      path: "/cm/emp_analysis",
      exact: true,
      component: require('@/pages/cm/emp_analysis/index.js').default || require('@/pages/cm/emp_analysis/index.js'),
      name: "会员分析",
    },
    {
      path: "/cm/order_list",
      exact: true,
      component: require('@/pages/order/order_list/index.js').default || require('@/pages/order/order_list/index.js'),
    },
    {
      path: "/cm/order_list/order_detail",
      exact: true,
      component: require('@/pages/order/order_detail/index.js').default || require('@/pages/order/order_detail/index.js'),
      name: "订单详情",
    },
    {
      path: "/coupon/coupon_list",
      exact: true,
      component: require('@/pages/coupon/coupon_list/index.js').default || require('@/pages/coupon/coupon_list/index.js'),
    },
    {
      path: "/coupon/coupon_list/cash",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "满减券",
    },
    {
      path: "/coupon/coupon_list/free_pass",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "免票券",
    },
    {
      path: "/coupon/coupon_issuance",
      exact: true,
      component: require('@/pages/coupon/coupon_issuance/index.jsx').default || require('@/pages/coupon/coupon_issuance/index.jsx'),
      name: "优惠券发放",
    },
    {
      path: "/coupon/coupon_issuance/add",
      exact: true,
      component: require('@/pages/coupon/coupon_issuance/coupon_issuance_form/index.jsx').default || require('@/pages/coupon/coupon_issuance/coupon_issuance_form/index.jsx'),
      name: "新建任务",
    },
    {
      path: "/coupon/coupon_list/discount",
      exact: true,
      component: require('@/pages/coupon/setting/index.jsx').default || require('@/pages/coupon/setting/index.jsx'),
      name: "折扣券",
    },
    {
      path: "/coupon/coupon_list/exchange",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "兑换券",
    },
    {
      path: "/coupon/coupon_list/gift",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "礼品券",
    },
    {
      path: "/coupon/coupon_list/group",
      exact: true,
      component: require('@/pages/coupon/setting/index.jsx').default || require('@/pages/coupon/setting/index.jsx'),
      name: "团购券",
    },
    {
      path: "/coupon/coupon_list/full-discount",
      exact: true,
      component: require('@/pages/coupon/setting/index.jsx').default || require('@/pages/coupon/setting/index.jsx'),
      name: "满折券",
    },
    {
      path: "/coupon/coupon_list/third",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "三方券",
    },
    {
      path: "/coupon/coupon_list/third_gift",
      exact: true,
      component: require('@/pages/coupon/coupon_form/index.jsx').default || require('@/pages/coupon/coupon_form/index.jsx'),
      name: "三方礼品券",
    },
    {
      path: "/coupon/coupon_list/coupon-detail",
      exact: true,
      component: require('@/pages/coupon/setting/index.jsx').default || require('@/pages/coupon/setting/index.jsx'),
      name: "优惠券详情",
    },
    {
      path: "/coupon/coupon_use",
      exact: true,
      component: require('@/pages/coupon/coupon_use_list/index.js').default || require('@/pages/coupon/coupon_use_list/index.js'),
      name: "优惠券核销",
    },
    {
      path: "/coupon/coupon_data",
      exact: true,
      component: require('@/pages/coupon/coupon_data/index.js').default || require('@/pages/coupon/coupon_data/index.js'),
      name: "优惠券数据",
    },
    {
      path: "/coupon/redemption_voucher_verification_department",
      exact: true,
      component: require('@/pages/coupon/redemption_voucher_verification_department/index.jsx').default || require('@/pages/coupon/redemption_voucher_verification_department/index.jsx'),
      name: "兑换券核销部门",
    },
    {
      path: "/coupon/redemption_voucher_verification_department/add",
      exact: true,
      component: require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx').default || require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx'),
      name: "新建",
    },
    {
      path: "/coupon/redemption_voucher_verification_department/edit",
      exact: true,
      component: require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx').default || require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx'),
      name: "编辑",
    },
    {
      path: "/coupon/redemption_voucher_verification_department/detail",
      exact: true,
      component: require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx').default || require('@/pages/coupon/redemption_voucher_verification_department/department_form/index.jsx'),
      name: "详情",
    },
    {
      path: "/coupon/redemption_voucher_verification_employee",
      exact: true,
      component: require('@/pages/coupon/redemption_voucher_verification_employee/index.jsx').default || require('@/pages/coupon/redemption_voucher_verification_employee/index.jsx'),
      name: "兑换券核销人员",
    },
    {
      path: "/marketing/scene",
      exact: true,
      component: require('@/pages/marketing/scene_marketing/index.js').default || require('@/pages/marketing/scene_marketing/index.js'),
    },
    {
      path: "/marketing/scene/ec_channels_reach",
      exact: true,
      component: require('@/pages/marketing/ec_channels_reach/index.jsx').default || require('@/pages/marketing/ec_channels_reach/index.jsx'),
    },
    {
      path: "/marketing/scene/festival",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "节日营销",
    },
    {
      path: "/marketing/scene/registration",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员注册营销",
    },
    {
      path: "/marketing/scene/birthday",
      exact: true,
      component: require('@/pages/marketing/add_marketing_birthday/index.js').default || require('@/pages/marketing/add_marketing_birthday/index.js'),
      name: "生日营销",
    },
    {
      path: "/marketing/scene/member",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员日营销",
    },
    {
      path: "/marketing/scene/bind",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员绑定",
    },
    {
      path: "/marketing/scene/consumption",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员消费",
    },
    {
      path: "/marketing/scene/level_change",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "等级变更",
    },
    {
      path: "/marketing/scene/point_use",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "积分使用",
    },
    {
      path: "/marketing/scene/repurchase",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员复购",
    },
    {
      path: "/marketing/scene/repurchase_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员复购",
    },
    {
      path: "/marketing/scene/ec_channels_reach_detail",
      exact: true,
      component: require('@/pages/marketing/ec_channels_reach/index.jsx').default || require('@/pages/marketing/ec_channels_reach/index.jsx'),
    },
    {
      path: "/marketing/scene/festival_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "节日营销",
    },
    {
      path: "/marketing/scene/registration_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员注册营销",
    },
    {
      path: "/marketing/scene/birthday_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing_birthday/index.js').default || require('@/pages/marketing/add_marketing_birthday/index.js'),
      name: "生日营销",
    },
    {
      path: "/marketing/scene/member_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员日营销",
    },
    {
      path: "/marketing/scene/bind_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员绑定",
    },
    {
      path: "/marketing/scene/consumption_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "会员消费",
    },
    {
      path: "/marketing/scene/level_change_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "等级变更",
    },
    {
      path: "/marketing/scene/point_use_detail",
      exact: true,
      component: require('@/pages/marketing/add_marketing/index.js').default || require('@/pages/marketing/add_marketing/index.js'),
      name: "积分使用",
    },
    {
      path: "/marketing/scene/activity-view",
      exact: true,
      component: require('@/pages/marketing/activity_view/index.js').default || require('@/pages/marketing/activity_view/index.js'),
      name: "运营数据",
    },
    {
      path: "/marketing/crowd",
      exact: true,
      component: require('@/pages/marketing/crowd_list/index.js').default || require('@/pages/marketing/crowd_list/index.js'),
    },
    {
      path: "/marketing/crowd/registered_unpaid",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "注册未支付人群",
    },
    {
      path: "/marketing/crowd/key_recall",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "重点召回人群",
    },
    {
      path: "/marketing/crowd/custom_crowd",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "自定义人群",
    },
    {
      path: "/marketing/crowd/assign_telephone",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "指定手机号人群",
    },
    {
      path: "/marketing/crowd/registered_unpaid_detail",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "注册未支付人群",
    },
    {
      path: "/marketing/crowd/key_recall_detail",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "重点召回人群",
    },
    {
      path: "/marketing/crowd/custom_crowd_detail",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "自定义人群",
    },
    {
      path: "/marketing/crowd/assign_telephone_detail",
      exact: true,
      component: require('@/pages/marketing/crowd_add/index.js').default || require('@/pages/marketing/crowd_add/index.js'),
      name: "指定手机号人群",
    },
    {
      path: "/marketing/activity",
      exact: true,
      component: require('@/pages/marketing/add_activity/index.js').default || require('@/pages/marketing/add_activity/index.js'),
      name: "活动运营",
    },
    {
      path: "/marketing/scene/activity-view",
      exact: true,
      name: "活动运营一览",
    },
    {
      path: "/marketing/account_activity_manage",
      exact: true,
      component: require('@/pages/marketing/account_activity_manage/index.js').default || require('@/pages/marketing/account_activity_manage/index.js'),
      name: "小程序活动管理",
    },
    {
      path: "/marketing/account_activity_manage/analyse",
      exact: true,
      component: require('@/pages/marketing/activity_analyse/index.js').default || require('@/pages/marketing/activity_analyse/index.js'),
      name: "活动分析",
    },
    {
      path: "/marketing/account_activity_detail",
      exact: true,
      component: require('@/pages/marketing/account_activity_detail/index.jsx').default || require('@/pages/marketing/account_activity_detail/index.jsx'),
      name: "活动详情",
    },
    {
      path: "/marketing/member_benefit_voucher",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher/index.js').default || require('@/pages/marketing/member_benefit_voucher/index.js'),
      name: "活动领券",
    },
    {
      path: "/marketing/member_benefit_voucher/add",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_edit/index.jsx').default || require('@/pages/marketing/member_benefit_voucher_edit/index.jsx'),
      name: "新建活动",
    },
    {
      path: "/marketing/member_benefit_voucher/edit",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_edit/index.jsx').default || require('@/pages/marketing/member_benefit_voucher_edit/index.jsx'),
      name: "编辑活动",
    },
    {
      path: "/marketing/member_benefit_voucher/detail",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_edit/index.jsx').default || require('@/pages/marketing/member_benefit_voucher_edit/index.jsx'),
      name: "查看活动",
    },
    {
      path: "/marketing/member_benefit_voucher/qr_code",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_qr/index.js').default || require('@/pages/marketing/member_benefit_voucher_qr/index.js'),
      name: "小程序码",
    },
    {
      path: "/marketing/luck_draw_view",
      exact: true,
      component: require('@/pages/marketing/luck_draw_view/index.js').default || require('@/pages/marketing/luck_draw_view/index.js'),
      name: "抽奖活动",
    },
    {
      path: "/marketing/luck_draw_view/luck_draw_view_setting_add",
      exact: true,
      component: require('@/pages/marketing/luck_draw_view_setting/index.jsx').default || require('@/pages/marketing/luck_draw_view_setting/index.jsx'),
      name: "新建活动",
    },
    {
      path: "/marketing/luck_draw_view/luck_draw_view_setting_edit",
      exact: true,
      component: require('@/pages/marketing/luck_draw_view_setting/index.jsx').default || require('@/pages/marketing/luck_draw_view_setting/index.jsx'),
      name: "编辑活动",
    },
    {
      path: "/marketing/luck_draw_view/luck_draw_view_setting_detail",
      exact: true,
      component: require('@/pages/marketing/luck_draw_view_setting/index.jsx').default || require('@/pages/marketing/luck_draw_view_setting/index.jsx'),
      name: "活动详情",
    },
    {
      path: "/marketing/luck_draw_view/qr_code",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_qr/index.js').default || require('@/pages/marketing/member_benefit_voucher_qr/index.js'),
      name: "小程序码",
    },
    {
      path: "/marketing/luck_draw_view/luck_draw_view_report",
      exact: true,
      component: require('@/pages/marketing/luck_draw_view_report/index.js').default || require('@/pages/marketing/luck_draw_view_report/index.js'),
      name: "活动分析",
    },
    {
      path: "/integral/gift_management",
      exact: true,
      component: require('@/pages/integral/gift_management/index.js').default || require('@/pages/integral/gift_management/index.js'),
      name: "礼品管理",
    },
    {
      path: "/integral/gift_management/management_gift_form_add",
      exact: true,
      component: require('@/pages/integral/management_gift_form/index.js').default || require('@/pages/integral/management_gift_form/index.js'),
      name: "新建礼品",
    },
    {
      path: "/integral/gift_management/management_gift_form_edit",
      exact: true,
      component: require('@/pages/integral/management_gift_form/index.js').default || require('@/pages/integral/management_gift_form/index.js'),
      name: "编辑礼品",
    },
    {
      path: "/integral/gift_management/management_gift_form_detail",
      exact: true,
      component: require('@/pages/integral/management_gift_form/index.js').default || require('@/pages/integral/management_gift_form/index.js'),
      name: "礼品详情",
    },
    {
      path: "/integral/goods_shelf_management",
      exact: true,
      component: require('@/pages/integral/goods_shelf_management/index.js').default || require('@/pages/integral/goods_shelf_management/index.js'),
      name: "货架管理",
    },
    {
      path: "/integral/goods_shelf_management/management_goods_shelf_form_add",
      exact: true,
      component: require('@/pages/integral/management_goods_shelf_form/index.js').default || require('@/pages/integral/management_goods_shelf_form/index.js'),
      name: "新建货架",
    },
    {
      path: "/integral/goods_shelf_management/management_goods_shelf_form_edit",
      exact: true,
      component: require('@/pages/integral/management_goods_shelf_form/index.js').default || require('@/pages/integral/management_goods_shelf_form/index.js'),
      name: "编辑货架",
    },
    {
      path: "/integral/goods_shelf_management/management_goods_shelf_form_detail",
      exact: true,
      component: require('@/pages/integral/management_goods_shelf_form/index.js').default || require('@/pages/integral/management_goods_shelf_form/index.js'),
      name: "货架详情",
    },
    {
      path: "/integral/goods_shelf_management/qr_code",
      exact: true,
      component: require('@/pages/marketing/member_benefit_voucher_qr/index.js').default || require('@/pages/marketing/member_benefit_voucher_qr/index.js'),
      name: "小程序码",
    },
    {
      path: "/integral/gift_exchange_record",
      exact: true,
      component: require('@/pages/integral/gift_exchange_record/index.js').default || require('@/pages/integral/gift_exchange_record/index.js'),
      name: "礼品兑换记录",
    },
    {
      path: "/integral/gift_exchange_record/gift_exchange_record_form_edit",
      exact: true,
      component: require('@/pages/integral/gift_exchange_record_form/index.js').default || require('@/pages/integral/gift_exchange_record_form/index.js'),
      name: "礼品兑换记录编辑",
    },
    {
      path: "/integral/gift_exchange_record/gift_exchange_record_form_detail",
      exact: true,
      component: require('@/pages/integral/gift_exchange_record_form/index.js').default || require('@/pages/integral/gift_exchange_record_form/index.js'),
      name: "礼品兑换记录详情",
    },
    {
      path: "/miniapps/qr_code",
      exact: true,
      component: require('@/pages/miniapps/qr_code/index.js').default || require('@/pages/miniapps/qr_code/index.js'),
      name: "小程序码",
    },
    {
      path: "/miniapps/qr_code/qr_code_add",
      exact: true,
      component: require('@/pages/miniapps/qr_code_create/index.js').default || require('@/pages/miniapps/qr_code_create/index.js'),
      name: "新建小程序码",
    },
    {
      path: "/miniapps/qr_code/qr_code_edit",
      exact: true,
      component: require('@/pages/miniapps/qr_code_create/index.js').default || require('@/pages/miniapps/qr_code_create/index.js'),
      name: "编辑小程序码",
    },
    {
      path: "/miniapps/qr_code/qr_code_detail",
      exact: true,
      component: require('@/pages/miniapps/qr_code_create/index.js').default || require('@/pages/miniapps/qr_code_create/index.js'),
      name: "小程序码详情",
    },
    {
      path: "/miniapps/template_list",
      exact: true,
      component: require('@/pages/message/wechat/templateList/index.js').default || require('@/pages/message/wechat/templateList/index.js'),
      name: "订阅消息",
    },
    {
      path: "/miniapps/template_list/addWmpTemplate",
      exact: true,
      component: require('@/pages/miniapps/addTemplate/index.js').default || require('@/pages/miniapps/addTemplate/index.js'),
      name: "新建订阅消息",
    },
    {
      path: "/miniapps/template_list/editWmpTemplate",
      exact: true,
      component: require('@/pages/miniapps/addTemplate/index.js').default || require('@/pages/miniapps/addTemplate/index.js'),
      name: "编辑订阅消息",
    },
    {
      path: "/adjust/adjust_list",
      exact: true,
      component: require('@/pages/adjust/adjust_list/index.js').default || require('@/pages/adjust/adjust_list/index.js'),
      name: "会员调整",
    },
    {
      path: "/adjust/adjust_list/unbind_member",
      exact: true,
      component: require('@/pages/adjust/remove_binding_vip/index.jsx').default || require('@/pages/adjust/remove_binding_vip/index.jsx'),
      name: "会员解绑",
    },
    {
      path: "/adjust/adjust_list/unbind_member_detail",
      exact: true,
      component: require('@/pages/adjust/remove_binding_vip/index.jsx').default || require('@/pages/adjust/remove_binding_vip/index.jsx'),
      name: "会员解绑详情",
    },
    {
      path: "/adjust/adjust_view/unbind_member_detail",
      exact: true,
      component: require('@/pages/adjust/remove_binding_vip/index.jsx').default || require('@/pages/adjust/remove_binding_vip/index.jsx'),
    },
    {
      path: "/adjust/adjust_list/edit",
      name: "编辑",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/edit",
      name: "生日",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_list/patch_coupon",
      name: "优惠券",
      exact: true,
      component: require('@/pages/adjust/patch_coupon/index.js').default || require('@/pages/adjust/patch_coupon/index.js'),
    },
    {
      path: "/adjust/adjust_list/changeStore",
      name: "转柜",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/changeStore",
      name: "转柜",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_list/changeLevel",
      name: "等级调整",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/changeLevel",
      name: "等级调整",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_list/changeIntegral",
      name: "积分调整",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/changeIntegral",
      name: "积分调整",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/changeMolding",
      name: "型动值调整",
      exact: true,
      component: require('@/pages/adjust/adjust_detail/index.js').default || require('@/pages/adjust/adjust_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view",
      exact: true,
      component: require('@/pages/adjust/adjust_view/index.js').default || require('@/pages/adjust/adjust_view/index.js'),
    },
    {
      path: "/adjust/adjust_view/adjust_view_detail",
      name: "会员调整详情",
      exact: true,
      component: require('@/pages/adjust/adjust_view/adjust_view_detail/index.js').default || require('@/pages/adjust/adjust_view/adjust_view_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/adjust_coupon_view_detail",
      name: "卡券变更",
      exact: true,
      component: require('@/pages/adjust/adjust_view/adjust_view_detail/index.js').default || require('@/pages/adjust/adjust_view/adjust_view_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/adjust_coupon_period_view_detail",
      name: "优惠券有效期调整",
      exact: true,
      component: require('@/pages/adjust/adjust_view/adjust_view_detail/index.js').default || require('@/pages/adjust/adjust_view/adjust_view_detail/index.js'),
    },
    {
      path: "/adjust/adjust_view/adjust_coupon_failure_view_detail",
      name: "优惠券失效调整",
      exact: true,
      component: require('@/pages/adjust/adjust_view/adjust_view_detail/index.js').default || require('@/pages/adjust/adjust_view/adjust_view_detail/index.js'),
    },
    {
      path: "/adjust/adjust_list/card_merge",
      exact: true,
      component: require('@/pages/adjust/card_merge/index.js').default || require('@/pages/adjust/card_merge/index.js'),
      name: "卡号合并",
    },
    {
      path: "/adjust/adjust_list/adjust_many",
      exact: true,
      name: "批量调整",
      component: require('@/pages/adjust/adjust_many/index.js').default || require('@/pages/adjust/adjust_many/index.js'),
    },
    {
      path: "/profile/label_manage",
      exact: true,
      name: "标签管理",
      component: require('@/pages/profile/label_manage/index.js').default || require('@/pages/profile/label_manage/index.js'),
    },
    {
      path: "/profile/crowd_manage",
      exact: true,
      name: "人群管理",
      component: require('@/pages/profile/crowd_manage/index.js').default || require('@/pages/profile/crowd_manage/index.js'),
    },
    {
      path: "/profile/crowd_manage/crowd_portrayal",
      exact: true,
      name: "人群画像",
      component: require('@/pages/profile/crowd_portrayal/index.js').default || require('@/pages/profile/crowd_portrayal/index.js'),
    },
    {
      path: "/profile/crowd_manage/crowd_import",
      exact: true,
      name: "导入外部人群",
      component: require('@/pages/profile/crowd_manage/crowd_import/index.js').default || require('@/pages/profile/crowd_manage/crowd_import/index.js'),
    },
    {
      path: "/profile/collection_label_edit",
      exact: true,
      name: "标签目录管理",
      component: require('@/pages/profile/collection_label_edit/index.js').default || require('@/pages/profile/collection_label_edit/index.js'),
    },
    {
      path: "/profile/crowd_manage/crowd_detail",
      exact: true,
      name: "人群详情",
      component: require('@/pages/profile/crowd_manage/crowd_detail/index.js').default || require('@/pages/profile/crowd_manage/crowd_detail/index.js'),
    },
    {
      path: "/profile/crowd_manage/crowd_create",
      exact: true,
      component: require('@/pages/profile/crowd_manage/crowd_create_copy/index.js').default || require('@/pages/profile/crowd_manage/crowd_create_copy/index.js'),
      name: "创建人群",
    },
    {
      path: "/profile/crowd_manage/crowd_edit",
      exact: true,
      component: require('@/pages/profile/crowd_manage/crowd_create_copy/index.js').default || require('@/pages/profile/crowd_manage/crowd_create_copy/index.js'),
      name: "创建人群",
    },
    {
      path: "/profile/crowd_manage/crowd_detail/rule_detail",
      exact: true,
      component: require('@/pages/profile/crowd_manage/crowd_create_copy/index.js').default || require('@/pages/profile/crowd_manage/crowd_create_copy/index.js'),
      name: "人群详情",
    },
    {
      path: "/profile/label_manage/collection_label",
      exact: true,
      name: "集合类标签",
      component: require('@/pages/profile/label_manage/collection_label/index.js').default || require('@/pages/profile/label_manage/collection_label/index.js'),
    },
    {
      path: "/profile/label_manage/sql",
      exact: true,
      name: "sql标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/import",
      exact: true,
      name: "导入标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/statistics",
      exact: true,
      name: "统计类标签",
      component: require('@/pages/profile/label_manage/statistics_create_label/index.js').default || require('@/pages/profile/label_manage/statistics_create_label/index.js'),
    },
    {
      path: "/profile/label_manage/collection_label_edit",
      exact: true,
      name: "集合类标签",
      component: require('@/pages/profile/label_manage/collection_label/index.js').default || require('@/pages/profile/label_manage/collection_label/index.js'),
    },
    {
      path: "/profile/label_manage/sql_edit",
      exact: true,
      name: "sql标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/import_edit",
      exact: true,
      name: "导入标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/statistics_edit",
      exact: true,
      name: "统计类标签",
      component: require('@/pages/profile/label_manage/statistics_create_label/index.js').default || require('@/pages/profile/label_manage/statistics_create_label/index.js'),
    },
    {
      path: "/profile/label_manage/collection_label_detail",
      exact: true,
      name: "集合类标签",
      component: require('@/pages/profile/label_manage/collection_label/index.js').default || require('@/pages/profile/label_manage/collection_label/index.js'),
    },
    {
      path: "/profile/label_manage/sql_detail",
      exact: true,
      name: "sql标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/import_detail",
      exact: true,
      name: "导入标签",
      component: require('@/pages/profile/label_manage/create_label/index.js').default || require('@/pages/profile/label_manage/create_label/index.js'),
    },
    {
      path: "/profile/label_manage/statistics_detail",
      exact: true,
      name: "统计类标签",
      component: require('@/pages/profile/label_manage/statistics_create_label/index.js').default || require('@/pages/profile/label_manage/statistics_create_label/index.js'),
    },
    {
      path: "/bre/dgm/der",
      exact: true,
      component: require('@/pages/bre/dgm/der/index.js').default || require('@/pages/bre/dgm/der/index.js'),
    },
    {
      path: "/bre/dgm/dgm/add",
      exact: true,
      component: require('@/pages/bre/dgm/dgm/add/index.js').default || require('@/pages/bre/dgm/dgm/add/index.js'),
    },
    {
      path: "/bre/dgm/dgm/dgmp/dgcl",
      exact: true,
      component: require('@/pages/bre/dgm/dgm/dgmp/dgcl/index.jsx').default || require('@/pages/bre/dgm/dgm/dgmp/dgcl/index.jsx'),
    },
    {
      path: "/bre/dgm/dgm/dgmp/dgic",
      exact: true,
      component: require('@/pages/bre/dgm/dgm/dgmp/dgic/index.jsx').default || require('@/pages/bre/dgm/dgm/dgmp/dgic/index.jsx'),
    },
    {
      path: "/bre/dgm/dgm/dgmp",
      exact: true,
      component: require('@/pages/bre/dgm/dgm/dgmp/index.jsx').default || require('@/pages/bre/dgm/dgm/dgmp/index.jsx'),
    },
    {
      path: "/bre/dgm/dgm",
      exact: true,
      component: require('@/pages/bre/dgm/dgm/index.jsx').default || require('@/pages/bre/dgm/dgm/index.jsx'),
    },
    {
      path: "/bre/dgm/dgt/test",
      exact: true,
      component: require('@/pages/bre/dgm/dgt/test/index.js').default || require('@/pages/bre/dgm/dgt/test/index.js'),
    },
    {
      path: "/bre/dgm/dgtb",
      exact: true,
      component: require('@/pages/bre/dgm/dgtb/index.js').default || require('@/pages/bre/dgm/dgtb/index.js'),
    },
    {
      path: "/bre/dgm/dr",
      exact: true,
      component: require('@/pages/bre/dgm/dr/index.js').default || require('@/pages/bre/dgm/dr/index.js'),
    },
    {
      path: "/bre/dgm/dvm",
      exact: true,
      component: require('@/pages/bre/dgm/dvm/index.js').default || require('@/pages/bre/dgm/dvm/index.js'),
    },
    {
      path: "/bre/fm/cfpm",
      exact: true,
      component: require('@/pages/bre/fm/cfpm/index.js').default || require('@/pages/bre/fm/cfpm/index.js'),
    },
    {
      path: "/bre/fm/cfpm_detail",
      exact: true,
      component: require('@/pages/bre/fm/cfpm_detail/index.js').default || require('@/pages/bre/fm/cfpm_detail/index.js'),
    },
    {
      path: "/bre/fm/tvf/cfg/c_handle_detail",
      exact: true,
      component: require('@/pages/bre/fm/tvf/cfg/c_handle_detail/index.js').default || require('@/pages/bre/fm/tvf/cfg/c_handle_detail/index.js'),
    },
    {
      path: "/bre/fm/tvf/cfg/c_unit_test",
      exact: true,
      component: require('@/pages/bre/fm/tvf/cfg/c_unit_test/index.js').default || require('@/pages/bre/fm/tvf/cfg/c_unit_test/index.js'),
    },
    {
      path: "/bre/fm/tvf/cfg",
      exact: true,
      component: require('@/pages/bre/fm/tvf/cfg/index.js').default || require('@/pages/bre/fm/tvf/cfg/index.js'),
    },
    {
      path: "/bre/fm/tvf",
      exact: true,
      component: require('@/pages/bre/fm/tvf/index.js').default || require('@/pages/bre/fm/tvf/index.js'),
    },
    {
      path: "/bre/mm/add",
      exact: true,
      component: require('@/pages/bre/mm/add/index.js').default || require('@/pages/bre/mm/add/index.js'),
    },
    {
      path: "/bre/mm",
      exact: true,
      component: require('@/pages/bre/mm/index.jsx').default || require('@/pages/bre/mm/index.jsx'),
    },
    {
      path: "/bre/mm/md/cfg",
      exact: true,
      component: require('@/pages/bre/mm/md/cfg/index.js').default || require('@/pages/bre/mm/md/cfg/index.js'),
    },
    {
      path: "/bre/mm/md",
      exact: true,
      component: require('@/pages/bre/mm/md/index.jsx').default || require('@/pages/bre/mm/md/index.jsx'),
    },
    {
      path: "/bre/mm/ol",
      exact: true,
      component: require('@/pages/bre/mm/ol/index.jsx').default || require('@/pages/bre/mm/ol/index.jsx'),
    },
    {
      path: "/bre/rm",
      exact: true,
      component: require('@/pages/bre/rm/index.js').default || require('@/pages/bre/rm/index.js'),
    },
    {
      path: "/bre/rm/rule/cfg/c_handle_detail",
      exact: true,
      component: require('@/pages/bre/rm/rule/cfg/c_handle_detail/index.js').default || require('@/pages/bre/rm/rule/cfg/c_handle_detail/index.js'),
    },
    {
      path: "/bre/rm/rule/cfg/c_unit_test",
      exact: true,
      component: require('@/pages/bre/rm/rule/cfg/c_unit_test/index.js').default || require('@/pages/bre/rm/rule/cfg/c_unit_test/index.js'),
    },
    {
      path: "/bre/rm/rule/cfg",
      exact: true,
      component: require('@/pages/bre/rm/rule/cfg/index.js').default || require('@/pages/bre/rm/rule/cfg/index.js'),
    },
    {
      path: "/bre/rm/rule",
      exact: true,
      component: require('@/pages/bre/rm/rule/index.js').default || require('@/pages/bre/rm/rule/index.js'),
    },
    {
      path: "/sm/rm",
      exact: true,
      component: require('@/pages/sm/rm/index.js').default || require('@/pages/sm/rm/index.js'),
    },
    {
      path: "/sm/um",
      exact: true,
      component: require('@/pages/sm/um/index.js').default || require('@/pages/sm/um/index.js'),
    },
    {
      path: "/dealer-customer/mm",
      exact: true,
      component: require('@/pages/cm/mm/index.js').default || require('@/pages/cm/mm/index.js'),
    },
    {
      path: "/dealer-customer/mm/ml",
      exact: true,
      component: require('@/pages/cm/mm/ml/index.js').default || require('@/pages/cm/mm/ml/index.js'),
      name: "会员详情",
    },
    {
      path: "/dealer/order_list",
      exact: true,
      component: require('@/pages/order/order_list/index.js').default || require('@/pages/order/order_list/index.js'),
    },
    {
      path: "/dealer/order_list/order_detail",
      exact: true,
      component: require('@/pages/order/order_detail/index.js').default || require('@/pages/order/order_detail/index.js'),
      name: "订单详情",
    },
    {
      path: "/dealer/ticket_order_list",
      exact: true,
      component: require('@/pages/order/stage-order/index.jsx').default || require('@/pages/order/stage-order/index.jsx'),
    },
    {
      path: "/dealer/ticket_order_list/order_detail",
      exact: true,
      component: require('@/pages/order/stage-order/detail/index.jsx').default || require('@/pages/order/stage-order/detail/index.jsx'),
    },
    {
      path: "/dealer-customer/emp_search",
      exact: true,
      component: require('@/pages/cm/emp_search/index.js').default || require('@/pages/cm/emp_search/index.js'),
      name: "会员查询",
    },
    {
      path: "/dealer-customer/emp_search/detail",
      exact: true,
      component: require('@/pages/cm/mm/ml/index.js').default || require('@/pages/cm/mm/ml/index.js'),
      name: "会员详情",
    },
    {
      path: "/my_task",
      exact: true,
      component: require('@/pages/task/my_task/index.jsx').default || require('@/pages/task/my_task/index.jsx'),
    },
    {
      path: "/data/user_behavior",
      exact: true,
      component: require('@/pages/data/user_behavior/index.jsx').default || require('@/pages/data/user_behavior/index.jsx'),
    },
    {
      path: "/data/user_behavior/detail",
      exact: true,
      component: require('@/pages/data/user_behavior_detail/index.jsx').default || require('@/pages/data/user_behavior_detail/index.jsx'),
    },
    {
      path: "/data/behavior_data",
      exact: true,
      component: require('@/pages/data/behavior_data/index.jsx').default || require('@/pages/data/behavior_data/index.jsx'),
    },
    {
      path: "/data_tools/activity",
      exact: true,
      name: "取数工具",
      component: require('@/pages/data_tools/activity_data_tools/index.js').default || require('@/pages/data_tools/activity_data_tools/index.js'),
    },
    {
      path: "/data_tools/export_invoice",
      exact: true,
      name: "开票申请导出",
      component: require('@/pages/data_tools/export_invoice/index.js').default || require('@/pages/data_tools/export_invoice/index.js'),
    },
    {
      path: "/login",
      exact: true,
      component: require('@/pages/login/index.js').default || require('@/pages/login/index.js'),
    },
    {
      path: "/",
      exact: true,
      component: require('@/pages/index.js').default || require('@/pages/index.js'),
      title: "homepage.title",
    },
    {
      path: "/system_management/user_management",
      exact: true,
      component: require('@/pages/user/user_query/index.jsx').default || require('@/pages/user/user_query/index.jsx'),
      title: "用户管理",
    },
    {
      path: "/public",
      exact: true,
      component: require('@/pages/public.jsx').default || require('@/pages/public.jsx'),
    },
    {
      path: "/develop",
      exact: true,
      component: require('@/pages/develop.jsx').default || require('@/pages/develop.jsx'),
    },
    {
      path: "/blank",
      exact: true,
      component: require('@/pages/blank.jsx').default || require('@/pages/blank.jsx'),
    },
    {
      path: "/403",
      exact: true,
      component: require('@/pages/403.jsx').default || require('@/pages/403.jsx'),
    },
    {
      component: require('@/pages/404.jsx').default || require('@/pages/404.jsx'),
    }
  ],
  }
];
